import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack/Stack";

import { layoutPublicStyle } from "../../styles/layout/public-routes";

export function FooterPublicRoutes() {
  return (
    <Stack component="footer" sx={layoutPublicStyle.footer}>
      <Stack direction="column" sx={{ width: "100%" }} marginLeft={2}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            textAlign: "center",
          }}
        >
          <Typography fontSize={13} style={{ margin: "5px 1px" }}>
            <b>CORPORATE LEGAL</b>
          </Typography>
          <div style={{ fontSize: "25px", margin: "5px 5px" }}>|</div>
          <Typography fontSize={13} style={{ margin: "5px 1px" }}>
            <b>ext. 2132</b>
          </Typography>
          <div style={{ fontSize: "25px", margin: "5px 5px" }}>|</div>
          <Typography fontSize={13} style={{ margin: "5px 1px" }}>
            <b>email: corporate.legal@binus.edu</b>
          </Typography>
        </div>
      </Stack>
    </Stack>
  );
}
